


export const modal = () => {

  const modal = document.querySelector(".presentations-modal");
  const modalInsert = document.querySelector(".presentations-modal__insert");

  const modalBtn = document.querySelectorAll(".download-presentation");

  const modalClose = document.querySelector(".presentations-modal__close");

  if ( modalBtn ) {
    for(let m = 0; m < modalBtn.length; m++){

      modalBtn[m].addEventListener("click",function(e){
        e.preventDefault();
    
        console.clear();
    
        modalInsert.innerHTML = ' ';
    
        var dataCount = modalBtn[m].nextElementSibling.childElementCount;
    
        for(var i = 0; i < dataCount; i++){
          modalInsert.insertAdjacentHTML(
            'beforeend', 
            `<div class="presentations-modal__block">
              <div class="presentations-modal__img">
                <img src="${modalBtn[m].nextElementSibling.children[i].dataset.img}" alt="">
              </div>
      
              <div class="presentations-modal__right">
                <div class="presentations-modal__name">${modalBtn[m].nextElementSibling.children[i].dataset.name}</div>
                <a href="${modalBtn[m].nextElementSibling.children[i].dataset.file}" target="_blank" class="btn-border presentations-modal__download">${modalBtn[m].nextElementSibling.children[i].dataset.btn}</a>
              </div>
            </div>`
          )
        }
    
        modal.classList.add("presentations-modal_open");
    
      });
  
    }
  }
  

  if ( modalClose ){

    modalClose.addEventListener("click",function(){
      modal.classList.remove("presentations-modal_open");
    });

    modal.addEventListener("click",function(event){
      if (this == event.target){
        modal.classList.remove("presentations-modal_open");
      }
    });

    document.addEventListener('keydown', function(e) {
      let keyCode = e.keyCode;
      if (keyCode === 27) {//keycode is an Integer, not a String
        modal.classList.remove("presentations-modal_open");
      }
    });

  }
  


}